module.exports = __webpack_public_path__ + "img/sfq-h5.b09ef6b2.png";